import { React, useEffect, useState } from "react";
import AppButton from "../../../../base/AppButton.component";
import {
  Divider,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  Typography,
} from "@mui/material";
import { Box, useTheme } from "@mui/system";
import { useMutation, useSubscription } from "@apollo/client";
import {
  CREATE_USER,
  UPDATE_USER,
} from "../../../../../graphql/mutation/mutation";
import { useAuth } from "../../../../../context/Auth.context";
import { CheckCircle } from "@mui/icons-material";
import { InputValidation } from "../../../../../utils/InputValidationRegex";
import { useAppContext } from "../../../../../context/App.context";
import { useParams } from "react-router-dom";
import { ON_EMPLOYEE_UPDATE } from "../../../../../graphql/subscription/subscription";

const UserDialog = (props) => {
  const theme = useTheme();
  const auth = useAuth();
  const params = useParams();
  const app = useAppContext();
  const [showSuccessMessage, setShowSuccessMessage] = useState(false);
  const [user, setUser] = useState({
    firstName: "",
    lastName: "",
    email: "",
    mobileNumber: "",
    designation: "manager",
    verifyNotification: 3,
    appointmentNotification: 3,
    receiveNotification: 3,
    assignTarget: 0,
    verification_workflow_id: 1,
  });

  const { row, edit = false } = props;
  const { data: onEmployeeUpdate } = useSubscription(ON_EMPLOYEE_UPDATE, {
    variables: {
      dealership_id: auth?.user?.dealership_id,
    },
  });
  const TableDataHandler = (response) => {
    let newData = response.employee.filter(
      (person) => person.employee_user_id !== auth.user.user_id
    );
    let managers = newData.filter((person) => person.role === "manager");
    let employees = newData.filter((person) => person.role === "employee");
    let firstData = response.employee.filter(
      (person) => person.employee_user_id === auth.user.user_id
    );

    app.setTarget([]);
    app.setTarget([...employees, ...firstData, ...managers]);
  };

  useEffect(() => {
    if (onEmployeeUpdate) {
      TableDataHandler(onEmployeeUpdate?.onEmployeeUpdate?.employee_details);
    }
  }, [onEmployeeUpdate]);
  useEffect(() => {
    if (row) {
      setUser({
        firstName: row.first_name,
        lastName: row.last_name,
        email: row.email,
        mobileNumber: row.mobile_number,
        designation: row.role,
        receiveNotification: row.notification_preference,
        verifyNotification: row.verification_preference,
        appointmentNotification: row.appointment_preference,
        assignTarget: row.assigned_target,
        verification_workflow_id: row?.verification_workflow_id,
      });
    }
  }, [row]);

  const [createUser, { loading: createLoading, data: createdUser }] =
    useMutation(CREATE_USER);
  const [updateUser, { loading: updateLoading, data: updatedUser }] =
    useMutation(UPDATE_USER);

  const createUserHandler = () => {
    createUser({
      variables: {
        createUserInput: {
          first_name: user.firstName,
          last_name: user.lastName,
          middle_name: "",
          email: user.email,
          mobile_number: user.mobileNumber.replace(/\D/g, ""),
          role: user.designation,
          notification_preference: user.receiveNotification,
          verification_preference: user.verifyNotification,
          appointment_preference: user.appointmentNotification,
          // current_target: user.assignTarget,
          created_by: auth.user.user_id,
          updated_by: auth.user.user_id,
          dealership_id: auth?.user?.dealership_id || params.dealershipId,
          d_startDate: app.fetchData.d_startDate,
          d_endDate: app.fetchData.d_endDate,
          f_startDate: app.fetchData.f_startDate,
          f_endDate: app.fetchData.f_endDate,
          timezone: new Date().getTimezoneOffset(),
          verification_workflow_id: user?.verification_workflow_id,
          isAdmin: false,
        },
      },
    }).then(() => {
      showSuccess();
    });
  };

  const updateUserHandler = () => {
    if (row?.employee_user_id === auth?.user?.user_id) {
      let index = auth?.user?.associateDetails?.findIndex((workflow) => {
        return workflow?.dealership_id === auth.user.dealership_id;
      });
      if (index !== -1) {
        const updatedWorkflow = [...auth?.user?.associateDetails];
        updatedWorkflow[index] = {
          ...updatedWorkflow[index],
          verification_workflow_id: user?.verification_workflow_id,
        };
        const updatedData = {
          ...auth?.user,
          first_name: user.firstName,
          last_name: user.lastName,
          associateDetails: updatedWorkflow,
        };
        auth.login(updatedData);
      }
    }
    updateUser({
      variables: {
        createUserInput: {
          user_id: row.employee_user_id,
          first_name: user.firstName,
          last_name: user.lastName,
          email: user.email,
          mobile_number: user.mobileNumber.replace(/\D/g, ""),
          notification_preference: user.receiveNotification,
          verification_preference: user.verifyNotification,
          appointment_preference: user.appointmentNotification,
          role: row.role,
          // current_target: user.assignTarget,
          created_by: auth.user.user_id,
          updated_by: auth.user.user_id,
          dealership_id: auth?.user?.dealership_id || params.dealershipId,
          employee_user_id: row?.user?.user_id,
          d_startDate: app.fetchData.d_startDate,
          d_endDate: app.fetchData.d_endDate,
          f_startDate: app.fetchData.f_startDate,
          f_endDate: app.fetchData.f_endDate,
          timezone: new Date().getTimezoneOffset(),
          verification_workflow_id: user?.verification_workflow_id,
          isAdmin: false,
        },
      },
    }).then(() => {
      showSuccess();
    });
  };
  const showSuccess = () => {
    setShowSuccessMessage(true);
    setTimeout(() => {
      setShowSuccessMessage(false);
    }, 2000);
  };
  return (
    <>
      <Divider />
      <Box sx={{ m: "16px" }}>
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <FormControl variant="outlined" sx={{ width: "48%" }}>
            <InputLabel
              color={
                InputValidation.nameValidation(user.firstName)
                  ? "error"
                  : "primary"
              }
            >
              First Name
            </InputLabel>
            <OutlinedInput
              required
              label="First Name"
              value={user.firstName}
              error={InputValidation.nameValidation(user.firstName)}
              onChange={(event) =>
                setUser({
                  ...user,
                  firstName: event.target.value,
                })
              }
            />
            <FormHelperText sx={{ color: theme.palette.error.main }}>
              {InputValidation.nameValidation(user.firstName)
                ? "Please enter a valid name"
                : " "}
            </FormHelperText>
          </FormControl>
          <FormControl variant="outlined" sx={{ width: "48%" }}>
            <InputLabel
              color={
                InputValidation.nameValidation(user.lastName)
                  ? "error"
                  : "primary"
              }
            >
              Last Name
            </InputLabel>
            <OutlinedInput
              required
              label="Last Name"
              value={user.lastName}
              onChange={(event) =>
                setUser({
                  ...user,
                  lastName: event.target.value,
                })
              }
              error={InputValidation.nameValidation(user.lastName)}
            />

            <FormHelperText sx={{ color: theme.palette.error.main }}>
              {InputValidation.nameValidation(user.lastName)
                ? "Please enter a valid name"
                : " "}
            </FormHelperText>
          </FormControl>
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: "8px",
          }}
        >
          <FormControl variant="outlined" sx={{ width: "48%" }}>
            <InputLabel
              color={
                InputValidation.emailValidation(user.email)
                  ? "error"
                  : "primary"
              }
            >
              Email
            </InputLabel>
            <OutlinedInput
              required
              label="Email"
              value={user.email}
              onChange={(event) =>
                setUser({
                  ...user,
                  email: event.target.value,
                })
              }
              error={InputValidation.emailValidation(user.email)}
            />
            <FormHelperText sx={{ color: theme.palette.error.main }}>
              {InputValidation.emailValidation(user.email)
                ? "Please enter a valid email"
                : " "}
            </FormHelperText>
          </FormControl>
          <FormControl variant="outlined" sx={{ width: "48%" }}>
            <InputLabel
              color={
                InputValidation.numberValidation(user.mobileNumber)
                  ? "error"
                  : "primary"
              }
            >
              Mobile Number
            </InputLabel>
            <OutlinedInput
              label="Mobile Number"
              value={InputValidation.phoneNumberFormat(user.mobileNumber)}
              type="tel"
              onChange={(event) =>
                setUser({
                  ...user,
                  mobileNumber: event.target.value,
                })
              }
              error={InputValidation.numberValidation(user.mobileNumber)}
            />
            <FormHelperText sx={{ color: theme.palette.error.main }}>
              {InputValidation.numberValidation(user.mobileNumber)
                ? "Please enter a valid mobile number"
                : " "}
            </FormHelperText>
          </FormControl>
        </Box>

        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: "10px",
          }}
        >
          <FormControl sx={{ width: "48%" }}>
            <InputLabel id="demo-simple-select-label">Designation</InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={user.designation}
              label="Designation"
              onChange={(e) => {
                setUser({
                  ...user,
                  designation: e.target.value,
                });
              }}
              disabled={edit}
            >
              <MenuItem value={"manager"}>Manager</MenuItem>
              <MenuItem value={"employee"}>Employee</MenuItem>
            </Select>
          </FormControl>
          <FormControl sx={{ width: "48%" }}>
            <InputLabel id="demo-simple-select-label">
              Verify Notification
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={user.verifyNotification}
              label="Verify Notification"
              onChange={(e) => {
                setUser({
                  ...user,
                  verifyNotification: e.target.value,
                });
              }}
            >
              <MenuItem value={3}>None</MenuItem>
              <MenuItem value={1}>Email</MenuItem>
              <MenuItem value={2}>Text</MenuItem>
            </Select>
          </FormControl>
        </Box>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            marginTop: "30px",
          }}
        >
          <FormControl sx={{ width: "48%" }}>
            <InputLabel id="demo-simple-select-label">
              Quote Notification
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={user.receiveNotification}
              label="Quote Notification"
              onChange={(e) => {
                setUser({
                  ...user,
                  receiveNotification: e.target.value,
                });
              }}
            >
              <MenuItem value={3}>None</MenuItem>
              <MenuItem value={1}>Email</MenuItem>
              <MenuItem value={2}>Text</MenuItem>
            </Select>
          </FormControl>
          <FormControl sx={{ width: "48%" }}>
            <InputLabel id="demo-simple-select-label">
              Appointment Notification
            </InputLabel>
            <Select
              labelId="demo-simple-select-label"
              id="demo-simple-select"
              value={user.appointmentNotification}
              label="Appointment Notification"
              onChange={(e) => {
                setUser({
                  ...user,
                  appointmentNotification: e.target.value,
                });
              }}
            >
              <MenuItem value={3}>None</MenuItem>
              <MenuItem value={1}>Email</MenuItem>
              <MenuItem value={2}>Text</MenuItem>
            </Select>
          </FormControl>
        </Box>
        <Box sx={{ marginTop: "24px" }}>
          <Typography variant="h6">Assign Target</Typography>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              gap: "15px",
            }}
          >
            <FormControl
              variant="outlined"
              sx={{ width: "100%", marginTop: "16px" }}
            >
              <InputLabel>Assign Target</InputLabel>
              <OutlinedInput
                required
                label="Assign Target"
                value={user.assignTarget}
                type="number"
                error={false}
                onChange={(event) =>
                  setUser({
                    ...user,
                    assignTarget: event.target.value,
                  })
                }
              />
              <FormHelperText> </FormHelperText>
            </FormControl>
            <FormControl
              variant="outlined"
              sx={{ width: "100%", marginTop: "16px" }}
            >
              <InputLabel id="demo-simple-select-label">Workflow</InputLabel>
              <Select
                value={user?.verification_workflow_id}
                label="Workflow"
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                // disabled={user.designation === "employee"}
                onChange={(e) => {
                  setUser({
                    ...user,
                    verification_workflow_id: e.target.value,
                  });
                }}
              >
                <MenuItem value={1}>Verify & Offer Quote</MenuItem>
                <MenuItem value={2}>Verify Only</MenuItem>
                <MenuItem value={3}>Offer Quote Only</MenuItem>
              </Select>
            </FormControl>
          </Box>
          {(createdUser?.createUser?.errors ||
            updatedUser?.updateUser?.errors) && (
            <Typography
              variant="body2"
              style={{ textAlign: "center", color: "red" }}
            >
              {createdUser?.createUser?.errors
                ? createdUser?.createUser?.errors[0].message
                : updatedUser?.updateUser?.errors[0].message}
            </Typography>
          )}
        </Box>
      </Box>

      <Divider />
      <Box
        sx={{
          mx: "16px",
          display: "flex",
          flexDirection: "row",
          justifyContent: "center",
          marginTop: "8px",
        }}
      >
        {edit ? (
          updatedUser?.updateUser?.dealership_id ? (
            <>
              {showSuccessMessage ? (
                <Box sx={{ display: "flex", my: "14px" }}>
                  {" "}
                  <CheckCircle color={"primary"} />
                  <span
                    style={{
                      color: theme.palette.primary.main,
                      marginLeft: "4px",
                    }}
                  >
                    SUCCESS
                  </span>
                </Box>
              ) : (
                <AppButton
                  buttonText="Update"
                  clickHandler={updateUserHandler}
                  size="medium"
                  variant="contained"
                  sx={{ width: "50%", my: 1 }}
                  disabled={
                    updateLoading ||
                    user.firstName === "" ||
                    user.lastName === "" ||
                    user.email === "" ||
                    user.mobileNumber === "" ||
                    InputValidation.nameValidation(user.firstName) ||
                    InputValidation.nameValidation(user.lastName) ||
                    InputValidation.numberValidation(user.mobileNumber) ||
                    InputValidation.emailValidation(user.email)
                  }
                  loading={updateLoading}
                />
              )}
            </>
          ) : (
            <AppButton
              buttonText="Update"
              clickHandler={updateUserHandler}
              size="medium"
              variant="contained"
              sx={{ width: "50%", my: 1 }}
              disabled={
                updateLoading ||
                user.firstName === "" ||
                user.lastName === "" ||
                user.email === "" ||
                user.mobileNumber === "" ||
                InputValidation.nameValidation(user.firstName) ||
                InputValidation.nameValidation(user.lastName) ||
                InputValidation.numberValidation(user.mobileNumber) ||
                InputValidation.emailValidation(user.email)
              }
              loading={updateLoading}
            />
          )
        ) : createdUser?.createUser?.dealership_id ? (
          <>
            {showSuccessMessage ? (
              <Box sx={{ display: "flex", my: "14px" }}>
                {" "}
                <CheckCircle color={"primary"} />
                <span
                  style={{
                    color: theme.palette.primary.main,
                    marginLeft: "4px",
                  }}
                >
                  SUCCESS
                </span>
              </Box>
            ) : (
              <AppButton
                buttonText="Create"
                clickHandler={createUserHandler}
                size="medium"
                variant="contained"
                sx={{ width: "50%", my: 1 }}
                disabled={
                  createLoading ||
                  user.firstName === "" ||
                  user.lastName === "" ||
                  user.email === "" ||
                  user.mobileNumber === "" ||
                  InputValidation.nameValidation(user.firstName) ||
                  InputValidation.nameValidation(user.lastName) ||
                  InputValidation.numberValidation(user.mobileNumber) ||
                  InputValidation.emailValidation(user.email)
                }
                loading={createLoading}
              />
            )}
          </>
        ) : (
          <AppButton
            buttonText="Create"
            clickHandler={createUserHandler}
            size="medium"
            variant="contained"
            sx={{ width: "50%", my: 1 }}
            disabled={
              createLoading ||
              user.firstName === "" ||
              user.lastName === "" ||
              user.email === "" ||
              user.mobileNumber === "" ||
              InputValidation.nameValidation(user.firstName) ||
              InputValidation.nameValidation(user.lastName) ||
              InputValidation.numberValidation(user.mobileNumber) ||
              InputValidation.emailValidation(user.email)
            }
            loading={createLoading}
          />
        )}
      </Box>
    </>
  );
};

export default UserDialog;
